import { UserProfile } from "../../application/UserProfile";
import { IMenuItem } from "./IMenuItem";
import { MenuItem } from "./MenuItem";

export const vsName = 'menu'

export class MenuService {
  private readonly menuItems: MenuItem[];
  private currentProfileUiMenuItems: IMenuItem[]

  constructor(menuItems: MenuItem[]) {
    this.menuItems = menuItems;
    this.currentProfileUiMenuItems = []
  }

  setProfile(profile: UserProfile | undefined) {
    if (profile === undefined) {
      return
    }
    const newProfile: UserProfile = profile
    this.currentProfileUiMenuItems = MenuService.mapToUiMenuItems(this.menuItems, newProfile)
  }

  getMenuItems(): IMenuItem[] {
    return this.currentProfileUiMenuItems
  }

  private static mapToUiMenuItems(menuItems: MenuItem[], profile: UserProfile): IMenuItem[] {
    return menuItems.map(mi => MenuService.mapToUiMenuItem(mi, undefined, profile)).filter((mi): mi is IMenuItem => mi !== undefined);
  }

  private static mapToUiMenuItem(menuItem: MenuItem, uiMenuItemParent: IMenuItem | undefined, profile: UserProfile): IMenuItem | undefined {
    const permission = menuItem.getRequiredPermission();
    if (permission && !profile.hasPermission(permission)) {
      return undefined;
    }

    const role = menuItem.getRequiredRole();
    if (role && !profile.hasRole(role)) {
      return undefined;
    }

    const anyPermission = menuItem.getAnyPermission()
    if (anyPermission && anyPermission.find(ap => profile.hasPermission(ap)) === undefined) {
      return undefined;
    }

    const uiMenuItem: IMenuItem = {
      getChildren: () => [],
      getDisplay: () => menuItem.getDisplay(),
      getId: () => menuItem.getId(),
      getParent: () => uiMenuItemParent,
      getState: () => menuItem.getState(),
      getActiveOnState: () => menuItem.getActiveOnState(),
      getExcludeActiveOnState: () => menuItem.getExcludeActiveOnState(),
      getImgSrc: () => menuItem.getImgSrc(),
      getAnyPermission: () => menuItem.getAnyPermission()
    };

    const children: IMenuItem[] = menuItem.getChildren().map(c => this.mapToUiMenuItem(c, uiMenuItem, profile)).filter((c): c is IMenuItem => c !== undefined);
    uiMenuItem.getChildren = () => children;

    return uiMenuItem;
  }
}
